import { data } from '../../svg/File/data';
import { makeIcon } from '../makeIcon';

export const File = makeIcon(data, 'file', 'File');

export default File;
